import messages from '@src/common/messages.json';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const registrationStatusError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;
  const { duration, endpoint, message } = res;
  const errorData = {
    status: faultCode,
    message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status === 404 || res.status === 500) {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_REGISTRATION_STATUS_FAILED,
    };
  }

  throw res;
};
